exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.account-table[data-v-be4317d4] {\n  border-top: 1px solid #000000;\n  border-left: 1px solid #000000;\n  margin: 10px;\n  border-spacing: inherit;\n}\n.account-table > tr > td[data-v-be4317d4] {\n  border-right: 1px solid #000000;\n  border-bottom: 1px solid #000000;\n  padding: 5px;\n}\n.blod-span[data-v-be4317d4] {\n  color: red;\n  font-weight: bold;\n}\n.mynone[data-v-be4317d4] {\n  display: none !important;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-be4317d4","scoped":true,"hasInlineConfig":false}!./node_modules/less-loader/dist/cjs.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/page/train/FBT/doudianExam.vue
// module id = 1737
// module chunks = 0